import { applyMiddleware, compose, createStore as createReduxStore } from 'redux'
import thunk from 'redux-thunk'
import { browserHistory } from 'react-router'
import makeRootReducer from './reducers'
import { updateLocation } from './location'
import createSagaMiddleware from 'redux-saga'
import { injectSagas } from './sagas'
import { questionSagas } from './sagas/sagas_question'
import { settingsSagas } from './sagas/sagas_settings'
import { productsSagas } from './sagas/sagas_products'
import { metricsSagas } from './sagas/sagas_metrics'
import { adminSagas } from './sagas/sagas_admin'
import { userSagas } from './sagas/sagas_user'
import { computedProductsSagas } from './sagas/sagas_computed_products'

import {initialState as questionsInitialState} from './modules/module_questions';
import {initialState as metricsInitialState} from './modules/module_metrics';
import { retrieveSettingsStorage, recuperarEstadoCuestionarios, retrieveMetricsStorage } from 'utilities/session-utils'

const settings = retrieveSettingsStorage() || {};
const estadoCuestionarios = recuperarEstadoCuestionarios() || {inclusion: true,socioCampana: true,socioBasico: true,menosSaludable: true,salida: true,salidaCampaign: true,};
const estadoMetricas = retrieveMetricsStorage() || metricsInitialState;
const createStore = (initialState = {
  settings,
  questions: {
    ...questionsInitialState,
    estadoCuestionarios: {...estadoCuestionarios}
  },
  metrics: estadoMetricas
}) => {
  // ======================================================
  // Middleware Configuration
  // ======================================================
  //const middleware = [thunk]
  const sagaMiddleware = createSagaMiddleware()
  const middleware = [sagaMiddleware]

  // ======================================================
  // Store Enhancers
  // ======================================================
  const enhancers = []
  let composeEnhancers = compose

  if (__DEV__) {
    if (typeof window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === 'function') {
      composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    }
  }

  // ======================================================
  // Store Instantiation and HMR Setup
  // ======================================================
  const store = createReduxStore(
    makeRootReducer(),
    initialState,
    composeEnhancers(
      applyMiddleware(...middleware),
      ...enhancers
    )
  )

  store.asyncReducers = {}
  store.asyncSagas = {}

  store.runSaga = (saga) => {
    sagaMiddleware.run(saga)
  }

  /*
  * Inyecta modulos de Sagas
  */
  injectSagas(store, { key: 'question', sagas: questionSagas })
  injectSagas(store, {key: 'settings', sagas: settingsSagas })
  injectSagas(store, {key: 'products', sagas: productsSagas })
  injectSagas(store, {key: 'metrics', sagas: metricsSagas })
  injectSagas(store, {key: 'admin', sagas: adminSagas })
  injectSagas(store, {key: 'user', sagas: userSagas })
  injectSagas(store, { key: 'computedProducts', sagas: computedProductsSagas })

  // To unsubscribe, invoke `store.unsubscribeHistory()` anytime
  store.unsubscribeHistory = browserHistory.listen(updateLocation(store))

  if (module.hot) {
    module.hot.accept('./reducers', () => {
      const reducers = require('./reducers').default
      store.replaceReducer(reducers(store.asyncReducers))
    })
  }

  return store
}

export default createStore



// WEBPACK FOOTER //
// ./src/store/createStore.js